import React from 'react'
import "./portfolio.css";
import Image1 from '../../assets/lms_clone_image.png';
import Image2 from '../../assets/todo_list_app.PNG';
import Image3 from '../../assets/resturant_app_pic.PNG';
const data=[
  {
    id:1,
    image:Image1,
    title:'Learning Managment System',
    github:'https://gitlab.com/devnation1/jan-21-web-development/squad-d/lms-clone',
    demo:'https://lms-app-8dba9.web.app/'
  },
  {
    id:2,
    image:Image2,
    title:'Todo list Application',
    github:'https://github.com/AbdulAhad-49/Todo_list_App',
    demo:'https://todo-list-app-a9254.web.app/'
  },
  {
    id:3,
    image:Image3,
    title:'Restaurant Menu Application',
    github:'https://github.com/AbdulAhad-49/Resturant_Menu_App',
    demo:'https://resturant-menu-app-9836d.web.app'
  }
 
]
const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map((item)=>{
          return(<>
           <article key={item.id} className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={item.image} alt="imageOne" />
          </div>
          <h3>{item.title}</h3>
          <div className="portfolio__item-cta">
          <a href={item.github} className="btn" target="_blank" rel="noreferrer">Github</a>
          <a href={item.demo} className="btn btn-primary" target="_blank" rel="noreferrer">Live Demo</a>
          </div>
        </article>
          </>)
        })}
       
        
      </div>
    </section>
  )
}

export default Portfolio